module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "img2",
      "src": "images/img2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Pension certificate granted in 1887 to former private Francis G. Barnes, Company I, Fourth Infantry. Barnes’s pension was for “Injury to left hand and resulting contraction of muscles of second, third and fourth fingers,” for which he was awarded fourteen dollars per month. Barnes died in 1921 in Hamburg, New York.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-285aba0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndianWarVeterans_introduction1.vue
// module id = 81
// module chunks = 0